import { graphql } from "gatsby";
import React from "react";
import { HalfPageTextComponent } from '../components/contents/index';
import SpacerComponent from "../components/contents/spacer";
import FooterComponent from '../components/footer/footer';
import { Container } from '../components/grid/grid.component';

class PlainPageTemplate extends React.Component {
  render() {
    const { data } = this.props;
    const page = data.page.data;
    return (
      <div>
        <SpacerComponent />
        <Container>
          <HalfPageTextComponent html={page.text.html} />
        </Container>
        <SpacerComponent />
        <FooterComponent />
      </div>
    )
  }
}
export default PlainPageTemplate;

export const query = graphql`
  query($slug: String!, $lang: String!) {
    page: prismicPlainTextPage(uid: { eq: $slug },lang: { eq: $lang }) {
      id
      lang
      uid
      data {
        text {
          html
        }
        seo_title
        seo_description
      }
    }
  }
`
